export default __webpack_public_path__ + "static/media/grabber_graph.11e96a5b.svg";